import Typography from '@mui/material/Typography';
import { createLink } from '@tanstack/react-router';

import { Button } from '@/shared/components/button';
import { ArrowRight } from '@/shared/components/icons';
import { CenterLogoLayout } from '@/shared/components/layouts';

const LinkButton = createLink(Button);

const LoggedOut = () => {
  return (
    <CenterLogoLayout>
      <Typography
        fontSize='1.25rem'
        fontWeight={400}
        lineHeight='1.875rem'
        textAlign='center'
        pb={3}
      >
        You&apos;ve been signed out.
      </Typography>

      <LinkButton
        variant='contained'
        size='small'
        fullWidth
        sx={{ fontSize: '1rem', fontWeight: 700, lineHeight: '1.5rem' }}
        endIcon={<ArrowRight />}
        to='/auth/login'
      >
        Sign in again
      </LinkButton>
    </CenterLogoLayout>
  );
};

export default LoggedOut;
